let dropDownZIndex = 0
$(".main-header").append($(".main-menu .main-menu-children"))

/*$(".main-menu > li.has-children > a").on("click", function (e) {
  e.preventDefault()
  const id = $(this).data("id")
  const dropdown = $(".main-menu-children[data-target=" + id + "]")
  if (dropdown.hasClass("active")) {
    dropdown.removeClass("active")
  } else {
    $(".main-menu-children.active").removeClass("active")
    dropdown.addClass("active").css("z-index", ++dropDownZIndex)
  }
})*/

$(".main-menu > li.has-children > a").on("click", function (e) {
  e.preventDefault()
})

$(".main-menu > li.has-children").on("mouseenter", function (e) {
  e.preventDefault()
  const id = $(this).find("> a").data("id")
  const dropdown = $(".main-menu-children[data-target=" + id + "]")
  $(".main-menu-children.active").removeClass("active")
  dropdown.addClass("active").css("z-index", ++dropDownZIndex)
})

/*$(document).on("mouseenter", function (e) {
  e.preventDefault()
  if (
    !$(".main-menu > li.has-children").is(e.target) &&
    $(".main-menu > li.has-children").has(e.target).length === 0 &&
    !$(".main-menu-children.active").is(e.target) &&
    $(".main-menu-children.active").has(e.target).length === 0
  ) {
    $(".main-menu-children.active").removeClass("active")
  }
})*/

/*$(".main-menu > li.has-children").on("mouseleave", function (e) {
  e.preventDefault()
  const id = $(this).find('> a').data("id")
  const dropdown = $(".main-menu-children[data-target=" + id + "]")
  dropdown.removeClass("active")
})*/

$(document).on("mouseup mouseleave", function (e) {
  const container = $(".main-menu-children.active")
  const links = $(".main-menu > li.has-children")
  if (
    !container.is(e.target) &&
    container.has(e.target).length === 0 &&
    !links.is(e.target) &&
    links.has(e.target).length === 0
  ) {
    container.removeClass("active")
  }
})

$("*").on("mouseenter", function (e) {
  const container = $(".main-menu-children.active")
  const links = $(".main-menu > li.has-children")
  if (
    !container.is(e.target) &&
    container.has(e.target).length === 0 &&
    !links.is(e.target) &&
    links.has(e.target).length === 0
  ) {
    container.removeClass("active")
  }
})

$(window).on("scroll", function (e) {
  $(".main-menu-children.active").removeClass("active")
})
